export const formatBookingAddress = (
  address: string | null | undefined,
  city: string | null | undefined,
  state: string | null | undefined,
  zipcode?: string | null
): string => {
  const trimmedAddress = address?.trim() ?? '';
  const capitalizedCity = city?.trim()
    ? city.trim().charAt(0).toUpperCase() + city.trim().slice(1).toLowerCase()
    : '';

  // If the API `address` is already a composite string that contains the city,
  // state, and ZIP (e.g. "10 Garfield Ave, Farmingdale, NY 11735, USA"), don't
  // append them again — that would duplicate "Farmingdale, NY 11735".
  const lcAddress = trimmedAddress.toLowerCase();
  const cityLower = city?.trim().toLowerCase() ?? '';
  const stateLower = state?.trim().toLowerCase() ?? '';
  const zipTrim = zipcode?.trim() ?? '';
  const addressHasCity = cityLower !== '' && lcAddress.includes(cityLower);
  const addressHasState = stateLower !== '' && lcAddress.includes(stateLower);
  const addressHasZip = zipTrim !== '' && lcAddress.includes(zipTrim);
  if (
    trimmedAddress !== '' &&
    addressHasCity &&
    addressHasState &&
    addressHasZip
  ) {
    return trimmedAddress;
  }

  const parts = [trimmedAddress, capitalizedCity, state?.trim()].filter(
    part => part != null && part !== ''
  ) as string[];

  const formatted = parts.join(', ');
  const zip = zipTrim;
  return zip ? `${formatted} ${zip}` : formatted;
};
